import { registerRequestInterceptor } from '../api';

registerRequestInterceptor((config) => {
  const isUploadFile = config?.data instanceof File;
  if (isUploadFile) {
    // eslint-disable-next-line no-console
    console.debug('[API] Upload file in FormData wrapper');
    const formData = new FormData();
    formData.append(
      'file',
      new Blob([config?.data], { type: 'application/octet-stream' }),
      config?.data.name
    );
    config.data = formData;
  }
  return config;
}, 'Upload file in FormData wrapper');
